
type ToggleLang = {
	title:string;
	name:string;
	flag:string;
}

export const toggleOptions:ToggleLang[] = [
	{
		title:"English",
		name:"en",
		flag:"/icons/flag-gb.svg"
	},
	{
		title:"Íslenska",
		name:"is",
		flag:"/icons/flag-is.svg"
	}
];